import React, { useEffect, useState } from "react";
import Dashboard from "../../../layouts/Dashboard";
import LoadingArea from "../../../components/LoadingArea";
import CandidatesTable from "../../../components/CandidatesTable";
import axios from "../../../services/axios";
import swal from "sweetalert";

export default function ReportsL3() {
  // States
  const [loading, setLoading] = useState(false);
  const [candidates, setCandidates] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [AppPage, setAppPage] = useState(
    localStorage.getItem("page") ? localStorage.getItem("page") : 1
  );
  const [LengthPages, setLengthPages] = useState(100);

  const [formIds, setFormIds] = useState("");
  const [locationName, setLocationName] = useState("");
  const [candidateStatus, setCandidateStatus] = useState("");
  const [processId, setProcessId] = useState("");
  const [Input, setInput] = useState("");
  const [candidateCount, setCandidateCount] = useState(0);

  const [startDates, setStartDates] = useState("");
  const [endDates, setEndDates] = useState("");

  const [csv, setCsv] = useState([]);

  const [score, setScore] = useState("");

  // Effects
  // useEffect(() => {
  //   loadCandidates();
  // }, []);

  // async function loadCandidates() {
  //   try {
  //      const res = await axios.get("candidates/small-l3");
  //    //const res = await axios.get("http://172.17.103.25:4000/api/candidates/candidateCount2?FormId=&PageSize=10&PageNo=1&Search=&Location=&Position=Kolkata&Status=&InterviewRound=3&ProcessId=");
  //     setCandidates(res.data.candidates);
  //     setLoading(false);
  //     setTotalPages(res.data.totalPages);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }
  localStorage.setItem("page", AppPage);
  const GetValue = (val) => {
    setAppPage(val.val);
  };
  const [load, setLoad] = useState(true);

  useEffect(() => {
    setFormIds(localStorage.getItem("form_ids"));
    if (formIds !== "") {
      setLoad(false);
    }
    {
      formIds !== "" &&
        setProcessId(
          localStorage.getItem("selectProcess")
            ? localStorage.getItem("selectProcess")
            : ""
        );
      setScore(
        localStorage.getItem("selectScore")
          ? localStorage.getItem("selectScore")
          : ""
      );
      setLocationName(
        localStorage.getItem("selectLocation")
          ? localStorage.getItem("selectLocation")
          : ""
      );
      setCandidateStatus(
        localStorage.getItem("selectStatus")
          ? localStorage.getItem("selectStatus")
          : ""
      );
    }

    {
      formIds !== "" &&
        axios
          .get(
            `candidates/candidateCount2?FormId=${formIds}&PageSize=10&PageNo=${
              localStorage.getItem("page") ? localStorage.getItem("page") : ""
            }&Search=${
              localStorage.getItem("numberSearch")
                ? localStorage.getItem("numberSearch")
                : ""
            }&Location=&Position=${
              localStorage.getItem("selectLocation")
                ? localStorage.getItem("selectLocation")
                : ""
            }&Status=${
              localStorage.getItem("selectStatus")
                ? localStorage.getItem("selectStatus")
                : ""
            }&InterviewRound=3&ProcessId=${
              localStorage.getItem("selectProcess")
                ? localStorage.getItem("selectProcess")
                : ""
            }&ScoreType=${
              localStorage.getItem("selectScore")
                ? localStorage.getItem("selectScore")
                : ""
            }&StartDate=${startDates}&EndDate=${endDates}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("user.token")}`,
              },
            }
          )
          .then((res) => {
            const data = res.data.interview;
            setLengthPages(res.data.interviewCount);
            setCandidateCount(res.data.interviewCount);
            setCandidates(data);
            if (data !== "") {
              setLoad(true);
            }
            setLoading(false);
            setTotalPages(res.data.totalPages);
          })
          .catch((e) => {
            setLoad(true);
            swal("Oops...", "Something went wrong!", "Network Error");
          });
    }
  }, [
    AppPage,
    formIds,
    locationName,
    candidateStatus,
    processId,
    Input,
    score,
    startDates,
    endDates,
  ]);

  const counts = `Candidates ${candidateCount}`;

  // filter download csv according to apply mltiple filters

  // useEffect(() => {
  //   axios.get(`candidates/DownloadInterviewCandidateCSV?FormId=${formIds}&PageSize=10&PageNo=1&Search=${Input}&Location=&Position=${locationName}&Status=${candidateStatus}&InterviewRound=3&ProcessId=${processId}
  //   `)
  //   .then(res => {
  //     const data = res.data.interview
  //     setCsv(data)
  //   })
  // }, [formIds, Input, , locationName, candidateStatus, processId])

  //const [csv, setCsv] = useState([])
  const [dataStatus, setDataStatus] = useState(true);
  const [sta, setSta] = useState();
  async function csvDownload() {
    try {
      setSta(false);
      const res = await axios.get(
        `candidates/DownloadInterviewCandidateCSV?FormId=${formIds}&PageSize=10&PageNo=1&Search=${
          localStorage.getItem("numberSearch")
            ? localStorage.getItem("numberSearch")
            : ""
        }&Location=&Position=${
          localStorage.getItem("selectLocation")
            ? localStorage.getItem("selectLocation")
            : ""
        }&Status=${
          localStorage.getItem("selectStatus")
            ? localStorage.getItem("selectStatus")
            : ""
        }&InterviewRound=1&ProcessId=${
          localStorage.getItem("selectProcess")
            ? localStorage.getItem("selectProcess")
            : ""
        }&ScoreType=${
          localStorage.getItem("selectScore")
            ? localStorage.getItem("selectScore")
            : ""
        }&StartDate=${startDates}&EndDate=${endDates}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      );
      setSta(true);
      setCsv(res.data.interview);
      return res.data.interview;
    } catch (e) {
      console.log(e);
    }
  }

  return (
    <Dashboard title={counts}>
      <LoadingArea isLoading={loading}>
        <CandidatesTable
          candidates={candidates}
          setCandidates={setCandidates}
          totalPages={totalPages}
          LengthPages={LengthPages}
          GetValue={GetValue}
          setFormIds={setFormIds}
          formIds={formIds}
          setLocationName={setLocationName}
          locationName={locationName}
          setCandidateStatus={setCandidateStatus}
          candidateStatus={candidateStatus}
          setProcessId={setProcessId}
          processId={processId}
          setInput={setInput}
          setAppPage={setAppPage}
          startDates={startDates}
          setStartDates={setStartDates}
          endDates={endDates}
          setEndDates={setEndDates}
          csv={csv}
          dataStatus={dataStatus}
          setDataStatus={setDataStatus}
          csvDownload={csvDownload}
          sta={sta}
          setSta={setSta}
          score={score}
          setScore={setScore}
          load={load}
          setLoad={setLoad}
        />
      </LoadingArea>
    </Dashboard>
  );
}
